import { action } from '@ember/object';
import { next } from '@ember/runloop';
import Component from '@glimmer/component';

import { SortFieldType } from 'webapp/enums/enums';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

const defaultIfEmpty = SortFieldType.VALUE;

export default class BlockSettingsSortFieldComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get visualization() {
		return this.blockSetup.visualization;
	}

	get selected(): SortFieldType {
		return this.block.sortField || defaultIfEmpty;
	}

	get options(): LabelValuePairString[] {
		const enabledOptions = this.visualization.enabledSortOptions;
		if (!enabledOptions.find((o) => o.value === this.selected)) {
			next(() => {
				this.changeSelected(defaultIfEmpty);
			});
		}
		return enabledOptions;
	}

	@action
	changeSelected(sortField: AnySimpleValue): void {
		this.blockSetup.changeSortField(sortField as SortFieldType);
	}
	<template>
		<div class="row">
			<label>Sort by</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="sortField"
				@selected={{this.selected}}
				@options={{this.options}}
				@onChange={{this.changeSelected}}
				@theme="dark-blue"
			/>
		</div>
	</template>
}
